import {
  DASHBOARD_ROLES,
  MISSION_ROLES,
  MUTUAL_DASHBOARD_ROLES,
  ROLE_GET_CORRESPONDANCE,
  ROLE_GET_MISSION_BILL_TABLE,
  ROLE_IMPORT_EXTERNAL_TRAINING,
  ROLE_TOOL_MANAGER,
  ROLE_TOOL_MANAGER_CLIENT,
  ROLE_TOOL_MANAGER_FAF,
  ROLE_TOOL_MANAGER_MISSION,
  ROLE_TOOL_MANAGER_PROSPECTION,
  ROLE_TOOL_MANAGER_SALARY,
  ROLE_TOOL_MANAGER_WORKER,
} from "access-roles/roles";
import ToggleSwitchButton from "core/buttons/toggle-switch-button/ToggleSwitchButton";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import { NOT_FOUND } from "./popup-codes";

export const DATEPICKER_DEFAULT_SETTINGS = {
  MAX_YEAR: 2050,
  MIN_YEAR: 2000,
  MAX_MONTH: 12,
  MIN_MONTH: 1,
  MAX_DAY: 31,
  MIN_DAY: 1,
};

export const DATEPICKER_DEFAULT_MIN_DATE = new Date(2000, 0, 1);
export const DATEPICKER_DEFAULT_MAX_DATE = new Date(2050, 11, 31);

export const LATE_MISSION_TYPE = {
  CREATED_LATE: "created-late",
  CLOSED_LATE: "closed-late",
  CLOSED_IN_TIME: "closed-in-time",
};

export const CANADA_BRANCH = "Davidson Canada INC";
export const CANADA_CONTRACT = "canada_temporary_contract";

export const FILTER_KEYS = {
  MISSION: "missions",
  DASHBOARD: "dashboard",
  SHARED_DASHBOARD: "shared_dashboard",
  TOOLS_MANAGER: "tools_manager",
};

export const COEF_POSITION_FUNCTION = {
  LEARN: "LEARN",
  STAGE: "STAGE",
};

export const MAX_LENGTH = 128;
export const PROFILE_ID = {
  ASSOC: "assoc",
};
export const VAR_TYPES = {
  DATE: "date",
  MULTI_DATES: "multi_dates",
  DROPDOWN: "dropdown",
  EMAIL: "email",
  NUMBER: "number",
  OBJECT: "object",
  STRING: "string",
  TAGS: "tags",
  TEXT: "text",
  SEARCH: "search",
  FILE: "file",
};

export const objAndRealizedTypes = [
  {
    label: { id: "initials", defaultMessage: "Initiaux" },
    value: 0,
  },
  {
    label: { id: "reforcasted", defaultMessage: "Reforcastés" },
    value: 1,
  },
];

export const MAX_LENGTH_SALARY = 99999.99;

export const MONTHS = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const CLIENT_TYPES = {
  HEADQUARTER: "headquarter",
  BRANCH: "branch",
  GEOGRAPHICAL_SITE: "geographical_site",
};

export const DOCX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export const PDF_MIME_TYPE = "application/pdf";

export const CONTRACT_TYPES = {
  CDI: "cdi",
  CDD: "cdd",
  REPRESENTATIVE: "representative",
};

export const PERMANENT_END_CONTRACT_TYPES_IDS = [
  "cdd_end",
  "contractual_resignation",
  "ct_app_end",
  "ct_pro_end",
  "death",
  "pension",
  "resignation",
  "resignation_client_hiring",
  "subcontractor_termination",
  "termination",
  "training_end",
  "trial_employee_end",
  "trial_employer_end",
];

export const SEARCH_TYPE = {
  TAG: "TAG",
  ARRAY: "ARRAY",
};

export const LANG = {
  EN: "en",
  FR: "fr",
};

export const DEFAULT_LANG = {
  FR: "FR",
  EN: "EN",
};

export const TOGGLE_SWITCH_STATUS = {
  ON: "on",
  NA: "na",
  OFF: "off",
};

export const ACTIONS = {
  LIST: "list",
  DETAILS: "details",
  EDIT: "edit",
  DELETE: "delete",
  CREATE: "create",
  UPDATE: "update",
  UPLOAD: "upload",
};

export const ENTITIES = {
  APPEAL: "appeal",
  BRANCH: "branch",
  COUNTRIES: "countries",
  COUNTRY_COEF: "country_coef",
  CURRENCY: "currency",
  JOB_CATEGORIES: "job_categories",
  JOBS: "jobs",
  PROFILE: "profile",
  REASON_LEAVE: "reasonleave",
  RECRUITMENT_METHOD: "recruitmentmethod",
  REGIONS: "regions",
  SECTOR: "sector",
  SYNTEC: "syntec",
  SYNTEC_POS_COEF: "syntecposcoef",
  SYNTEC_POS_COEF_STAFF: "syntecposcoef_staff",
  TTV: "ttv",
  TYPE_COMPANIES: "typecompanies",
  EXCHANGE_RATE: "echange_rate",
  BACKUP_MANAGER: "backup_manager",
  COUNTRY_HOLIDAYS: "country_holidays",
  DOCUMENT: "document",
};

export const CONTRACTUAL_STATUS = {
  EXECUTIVE: "Executive",
  NO_EXECUTIVE: "No executive",
  INTERNSHIP: "Internship",
};

export const VISA = {
  ADD: "add",
  EDIT: "edit",
  DISPLAY: "display",
};

export const SECTIONS = {
  PERSONAL: "PERSONAL",
  DASHBOARD: "DASHBOARD",
  CLIENTS: "CLIENTS",
  MISSIONS: "MISSIONS",
  GENERAL_INFO: "GENERAL_INFO",
  SUBCONTRACTORS: "SUBCONTRACTORS",
  BILLING: "BILLING",
};

export const MANAGER_TOOLS_PATH = "manager-tools";

export const MANAGER_TOOLS_SECTIONS = {
  prospections: "prospections",
  abaque: "abaque",
  missions: "missions",
  clients: "clients",
  consultants_subcontractors: "consultants-subcontractors",
  faf: "faf",
};

export const DELIVERY_NOTES_SECTIONS = {
  templates: "templates",
  create: "create",
  generate: "generate",
  saved: "saved",
};

export const DELIVERY_NOTE_COLUMN_TYPES = {
  SIMPLE: "simple",
  LINKED: "linked",
};

// Bounds the share route enforces (delivery_note_template.model.rs), mirrored
// so the fields stop the user first.
export const DELIVERY_NOTE_SHARE_LIMITS = {
  maxColleagues: 50,
  maxMessage: 2000,
};

// Currencies offered by the template form, taken from the currency referential
// (/settings/currency). Its `currency_id` column holds the alphabetic code.
// Widening the offer is a matter of extending this list.
export const DELIVERY_NOTE_CURRENCY_CODES = ["EUR", "USD"];

// Logos and signatures are stored as data URLs inside the template itself, so
// they are downscaled before being kept: a full resolution picture would blow
// up the payload for a preview that never exceeds a few hundred pixels.
export const DELIVERY_NOTE_IMAGE_MAX_SIZE = 300;

export const DASHBOARD_SHARED_SECTIONS = {
  ic: "ic",
  fdm: "fdm",
  ed: "ed",
  ok: "ok",
  cl: "cl",
  ko: "ko",
};

// Client placeholder written by the legacy F&F import; never shown to users.
export const FAF_LEGACY_NEED_CLIENT_PLACEHOLDER = "Import F&F";

export const QUERY_STATUS = {
  INITIAL: "INITIAL",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  DUPLICATE_EMAIL: "DUPLICATE_EMAIL",
  LOADING: "LOADING",
  NOT_FOUND: "NOT_FOUND",
};

export const INITIAL_MODAL_FEEDBACK = {
  open: false,
  status: QUERY_STATUS.INITIAL,
  messages: {},
};

export const PROFILE_ID_DEFAULT = {
  CONSULTANT: "cslt",
  STAFF: "staff",
};

export const CSLT_DEF_ROLE = ["ROLE_CSLT"];

export const RECRUITMENT_METHOD = {
  REFERER_EXTERNAL: "referer_external",
  REFERER_INTERNAL: "referer_internal",
};

export const MODULES = {
  SETTINGS: "settings",
  DIRECTORY: "directory",
};

export const TAG_TYPES = {
  BRANCHES: "branche",
  FUNCTIONS: "job",
  SECTORS: "sector",
  PEOPLE: "people",
  POS_COEF: "coefficient",
  ROLES: "roles",
  RECRUITMENT_MODE: "recruitment_mode",
  SKILLS: "skills",
  TAX_REGIME: "tax_regime",
  CLIENTS: "clients",
  CSLT_STR: "cslt_str",
  PROFILES: "profiles",
  PROSPECTIONS: "prospections",
  MOBILITY: "mobility",
  LEAVING_REASON: "leaving_reason",
  CSLT: "cslt",
  STR: "str",
  BILLING_CLIENT: "billing_clients",
  CONTACT: "contact",
};

export const MAX_FILE_SIZE = 5000000;

export const LOGIN_ALTERNATIVES = {
  SSO: "SSO",
  NORMAL: "NORMAL",
};

export const STATUS_MISSION = {
  BACKUP: "status_backup",
  FDM: "status_fdm",
  OK: "status_ok",
  ONE: "status_one",
  ZERO: "status_zero",
  HD: "HD",
  IC: "IC",
  ED: "ED",
  CL: "CL",
};
export const ED_STATUS_LABEL = "ENTREE";
export const MISSION_IN_PROGRESS_LABEL = {
  FR: "(en cours)",
  EN: "(in progress)",
};

export const DEFAULT_STATUS_MISSION = [
  {
    value: STATUS_MISSION.ONE,
    label: "1",
    color: "light-lime-green",
    type: "status-1",
  },
  {
    value: STATUS_MISSION.OK,
    label: "OK",
    color: "green-blue-1",
    type: "status-ok",
  },
  {
    value: STATUS_MISSION.FDM,
    label: "FDM",
    color: "light-yellow",
    type: "status-fdm",
  },
];

export const DATATRACK_MODELS = {
  CONTRACT: "contract",
  JOB_HISTORY: "domain",
  cl: "longleave",
  MANAGER: "manager",
  POS_COEF: "coef",
  SALARY: "salary",
  INTERNAL_TRAINING_COMMENTS: "internal_training_comments",
  DASHBOARD_COMMENTS: "dashboard_comment",
};

export const REQUIRED_ROLE_BY_DATATRACK_ACTION = {
  CREATE: [
    DATATRACK_MODELS.INTERNAL_TRAINING_COMMENTS,
    DATATRACK_MODELS.DASHBOARD_COMMENTS,
  ],
  DELETE: [
    DATATRACK_MODELS.INTERNAL_TRAINING_COMMENTS,
    DATATRACK_MODELS.DASHBOARD_COMMENTS,
  ],
};

export const MODAL_CONTENT = {
  MANAGE_MANAGERS: "manager",
  MANAGE_LONG_LEAVE: "longleave",
  MANAGE_POSITION_COEF: "coef",
  MANAGE_SALARY: "salary",
  MANAGE_WORK_CONTRACT: "contract",
  MANAGE_JOB_HISTORY: "domain",
  MANAGE_COMPANY_HISTORY: "subcontractor_company",
  MANAGE_DAILY_FEE: "daily_fee",
  MANAGE_HISTORY_MANAGERS: "manage_history_managers",
  MANAGE_BILLING_CLIENT_HISTORY: "manage_billings_client_history",
  MANAGE_MISSION_DETACHMENT: "manage_mission_detachment",
  MANAGE_EXTERNAL_TRAINING: "external_training",
};

export const TARIFICATION_TYPE = {
  DAILY: "tarification",
  OTHER: "other",
};

export const CONSULTANT_MISSION_STATUS = {
  STATUS_OK: "status_ok",
  STATUS_ONE: "status_one",
  STATUS_FDM: "status_fdm",
  STATUS_BACKUP: "status_backup",
  STATUS_ZERO: "status_zero",
  STATUS_ED: "status_ed",
  STATUS_EMPTY: "status_empty",
  STATUS_OUT: "status_out",
  STATUS_IC: "status_ic",
  STATUS_CL: "status_cl",
  OK: "OK",
  STATUS_1: "1",
  FDM: "FDM",
  BACKUP: "BACKUP",
  STATUS_0: "0",
  ZERO: "O",
  ED: "ED",
  OUT: "OUT",
  IC: "IC",
  CL: "CL",
  HD: "HD",
  EMPTY: "Empty",
};

export const INTERVIEW_STATUS = {
  ENABLED: "enabled",
  DISABLED: "disabled",
  ACTIVE: "active",
};

export const TAD_DAYS = [
  { label: { id: "monday", defaultMessage: "LUN" }, value: "monday" },
  { label: { id: "tuesday", defaultMessage: "MAR" }, value: "tuesday" },
  { label: { id: "wednesday", defaultMessage: "MER" }, value: "wednesday" },
  { label: { id: "thursday", defaultMessage: "JEU" }, value: "thursday" },
  { label: { id: "friday", defaultMessage: "VEN" }, value: "friday" },
];

export const EXPERIENCE_OPTIONS = [
  {
    label: { id: "zero_year", defaultMessage: "0 an (-1 an)" },
    value: "",
  },
  {
    label: { id: "one_year", defaultMessage: "1 an" },
    value: "",
  },
  {
    label: { id: "two_years", defaultMessage: "2 ans (+1 an)" },
    value: "",
  },
  {
    label: { id: "three_years", defaultMessage: "3 ans (+2 ans) " },
    value: "",
  },
];

export const PROSPECTION_DEFAULT_COLORS = [
  {
    key: "1",
    value: "green",
    component: (
      <div key="1" className="color-option">
        <ToggleSwitchButton
          index={`green`}
          value={TOGGLE_SWITCH_STATUS.ON}
          disabled
        />
        <Typography
          className="title-5 chateau-green"
          type="span"
          label={
            <FormattedMessage
              id="motivated-managers-welcome"
              defaultMessage="Managers motivés bienvenus"
            />
          }
        />
      </div>
    ),
  },
  {
    key: "2",
    value: "orange",
    component: (
      <div key="2" className="color-option">
        <ToggleSwitchButton
          index={`orange`}
          value={TOGGLE_SWITCH_STATUS.NA}
          disabled
        />
        <Typography
          className="title-5 gamboge"
          type="span"
          label={
            <FormattedMessage
              id="we-can-watch"
              defaultMessage="On peut regarder"
            />
          }
        />
      </div>
    ),
  },
  {
    key: "3",
    value: "red",
    component: (
      <div key="3" className="color-option">
        <ToggleSwitchButton
          index={`red`}
          value={TOGGLE_SWITCH_STATUS.OFF}
          disabled
        />
        <Typography
          className="title-5 alizarin-crimson"
          type="span"
          label={
            <FormattedMessage
              id="no-thank-you-the-playground-is-well-squared"
              defaultMessage="Non merci le terrain de jeu est bien quadrillé"
            />
          }
        />
      </div>
    ),
  },
];

export const EXITS_COMPANIES_BY = [
  {
    label: { id: "all", defaultMessage: "Tous" },
    value: "all",
  },
  {
    label: { id: "consultant", defaultMessage: "Consultant" },
    value: "consultant",
  },
  {
    label: { id: "subcontractor", defaultMessage: "Sous-traitant" },
    value: "subcontractor",
  },
];

export const ADD_PROSPECTION_ERROR = {
  ERROR_MAX_PROSPECTION: "ERROR_MAX_PROSPECTION",
  ERROR_PROSPECTION_ALREADY_EXIST: "ERROR_PROSPECTION_ALREADY_EXIST",
};

export const USER_TYPE = [
  {
    label: { id: "all", defaultMessage: "Tous" },
    value: "all",
  },
  {
    label: { id: "consultants", defaultMessage: "Consultants" },
    value: "consultants",
  },
  {
    label: { id: "candidates", defaultMessage: "Candidats" },
    value: "candidates",
  },
  {
    label: { id: "others", defaultMessage: "Autre" },
    value: "others",
  },
];

export const CORRESPONDENCE_TABLE_CSLT_STR_FILTER_OPTIONS = [
  {
    label: { id: "all_consultants", defaultMessage: "Tous les consultants" },
    value: "cslt",
  },
  {
    label: {
      id: "all_subcontractors",
      defaultMessage: "Tous les sous-traitants",
    },
    value: "str",
  },
  {
    label: {
      id: "all",
      defaultMessage: "Tous",
    },
    value: "All",
  },
];

export const INPUTS_IDS = {
  CONSULTANT: "consultant",
  STAFF: "staff",
  SUBCONTRACTOR: "Subcontractor",
  CLIENT: "client",
};

export const FILTERS = {
  CSLT: "cslt",
};

export const OBJECTIVES_ERRORS = {
  ERROR_MULTIPLE_OBJECTIVES: "same_objective_type_error",
  ERROR_TYPE_MISMATCH: "reforecast_type_before_initial_error",
  ERROR_TYPE_MISSING_MONTHLY_DATA: "missing_monthly_data_error",
  ERROR_TYPE_MISSING_YEAR: "missing_year_error",
  ERROR_TYPE_INIT_OBJECTIVE_REFORCASTED: "objectives_init_delete_ko",
};

export const POPUP_STATUS = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
};

// How long a confirmation or an error stays on screen, wherever it is rendered.
export const ALERT_DISPLAY_DELAY = 8000;

export const DELIVERY_NOTE_FILTERS_ENABLED = false;

export const DELIVERY_NOTE_REQUEST_TIMEOUT = 60000;

export const DELIVERY_NOTE_PDF_NAME_MODES = {
  AUTOMATIC: "automatic",
  CUSTOM: "custom",
};

export const DELIVERY_NOTE_NUMBER_EXAMPLE = "BROUL-CELAD-2609-001";

export const SIREN_SEARCH_ENTITY = {
  BILLING_CLIENT: "billing_client",
  SUBCONTRACTING_COMPANY: "subcontractor_company",
};

export const FRANCE_NATIONALITY_ID = 1;

export const MISSION_STATUS_FILTERS = [
  {
    value: "status_fdm",
    label: "FDM",
    color: "light-yellow",
    type: "status-fdm",
    id: "status_fdm",
  },
  {
    value: "status_ok",
    label: "OK",
    color: "green-blue-1",
    type: "status-ok",
    id: "status_ok",
  },
  {
    value: "status_one",
    label: "1",
    color: "light-lime-green",
    type: "status-1",
    id: "status_one",
  },
  {
    value: "status_zero",
    label: "0",
    color: "selago",
    type: "status-0",
    id: "status_zero",
  },
  {
    value: "status_backup",
    label: "Backup",
    color: "selago",
    type: "status-backup",
    id: "status_backup",
  },
];

export const VISIBLE_COLUMNS_LIST = [
  {
    index: 1,
    label: { id: "mission_name", defaultMessage: "nom de la mission" },
    value: "mission_name",
  },
  {
    index: 2,
    label: { id: "mission_status", defaultMessage: "Status" },
    value: "mission_status",
  },
  {
    index: 3,
    label: { id: "client_name", defaultMessage: "Client" },
    value: "client_name",
  },
  {
    index: 4,
    label: { id: "mission_start_date", defaultMessage: "Beginning" },
    value: "mission_start_date",
  },
  {
    index: 5,
    label: { id: "mission_end_date", defaultMessage: "End" },
    value: "mission_end_date",
  },
  {
    index: 6,
    label: { id: "mission_scheduled_end_date", defaultMessage: "End order" },
    value: "mission_scheduled_end_date",
  },
  {
    index: 7,
    label: { id: "manager_name", defaultMessage: "Manager" },
    value: "manager_name",
  },
  {
    index: 8,
    label: { id: "mission_current_fee", defaultMessage: "Fee" },
    value: "mission_current_fee",
  },
  {
    index: 9,
    label: { id: "worker_name", defaultMessage: "Cslt/STR" },
    value: "worker_name",
  },
  {
    index: 10,
    label: { id: "worker_status", defaultMessage: "Status Cslt/STR" },
    value: "worker_status",
  },
  {
    index: 11,
    label: { id: "mission_signed_by_name", defaultMessage: "Case signed by" },
    value: "mission_signed_by_name",
  },
  {
    index: 12,
    label: {
      id: "mission_charged_by_name",
      defaultMessage: "Business billed by",
    },
    value: "mission_charged_by_name",
  },
  {
    index: 13,
    label: { id: "mission_adv_name", defaultMessage: "ADV Manager" },
    value: "mission_adv_name",
  },
  {
    index: 14,
    label: { id: "mission_analytical_code", defaultMessage: "Analytical code" },
    value: "mission_analytical_code",
  },
];
export const MISSION_TYPE = [
  {
    label: { id: "dav", defaultMessage: "Davidson" },
    value: "dav",
  },
  {
    label: { id: "casquette", defaultMessage: "Portage par Davidson" },
    value: "casquette",
  },
  {
    label: {
      id: "portage",
      defaultMessage: "Portage pour Davidson",
    },
    value: "portage",
  },
];

export const FIELDS_TYPES = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  INLINE_RADIO: "INLINE_RADIO",
  VERTICAL_RADIO: "VERTICAL_RADIO",
  TEXT_AREA: "TEXTAREA",
  FIELD_SUM: "FIELD_SUM",
  DATE: "DATE",
  NUMBER: "NUMBER",
  CHOICE: "CHOICE",
  LABEL: "LABEL",
  INTEGER: "INTEGER",
  ENTITY: "ENTITY",
  INLINE_CHECK: "INLINE_CHECK",
  VERTICAL_CHECK: "VERTICAL_CHECK",
  HIDDEN: "HIDDEN",
  FILE: "FILE",
  RANGE: "RANGE",
  BASIC: "BASIC",
};

export const MODULES_TYPES = {
  LIST: "LIST",
  TABLE: "TABLE",
  TITLE: "TITLE",
  MR_IC_MODULE: "MR_IC_MODULE",
  MR_MISSION_MODULE: "MR_MISSION_MODULE",
  MR_MISSION_MODULE_CNT: "MR_MISSION_MODULE_CNT",
  MR_MISSION_MODULE_MGR: "MR_MISSION_MODULE_MGR",
  MR_SECOND_MODULE_MAIN: "MR_SECOND_MODULE_MAIN",
  MR_SECOND_MODULE_NT: "MR_SECOND_MODULE_NT",
  MR_SECOND_MODULE: "MR_SECOND_MODULE",
  MR_NOTE: "MR_NOTE",
  MR_EVALUATIONRECAP: "MR_EVALUATIONRECAP",
  MR_MISSIONMANAGER: "MR_MISSIONMANAGER",
  BASIC: "BASIC",
};

export const BALANCESHEET_CSS_CLASSES = {
  MISSION_ROW: "mission-row",
};

export const BALANCESHEET_DESIGN_WIDTH = 1320;

export const FIELD_LABEL = {
  NB_MONTHS: "Nombre de mois",
  NB_MONTHS_EN: "Number of months",
  PERIOD_FACTS: "Faits significatifs sur la période",
};

export const REMOTE_WORK_TAGS = {
  NOT_ALLOWED: "not-allowed",
  VOLUNTARY: "voluntary",
  CLIENT_IMPOSED: "client-imposed",
};

export const WORKER_TYPES = {
  SUBCONTRACTOR: "str",
  CONSULTANT: "cslt",
};

export const LEAVING_REASONS = {
  MUTATION: "mutation",
  CONTRACT_CHANGE: "contract_change",
};

export const BACKUP_VALUES = {
  DOUBLE_BILLING: "double_billing",
  TEMPORARY_BACKUP: "temporary_backup",
  DEFINITIVE_BACKUP: "definitive_backup",
};

export const BACKUP_OPTIONS = [
  {
    val: BACKUP_VALUES.DOUBLE_BILLING,
    lb: {
      id: "double_billing_option",
      defaultMessage:
        "Double facturation : création d'une nouvelle mission (sans utilisation de la fonction BACKUP, inutile dans ce cas)",
    },
  },
  {
    val: BACKUP_VALUES.DEFINITIVE_BACKUP,
    lb: {
      id: "definitive_backup_option",
      defaultMessage:
        "Le consultant sortant ne reviendra plus sur la mission OU je ne connais pas la date de retour (je referai un BACKUP le jour J)",
    },
  },
  {
    val: BACKUP_VALUES.TEMPORARY_BACKUP,
    lb: {
      id: "temporary_backup_option",
      defaultMessage:
        "Backup temporaire : Je connais les dates de début et de fin de backup, le consultant revenant sur sa mission",
    },
  },
];
export const INPUT_PICTURE_OPTIONS = {
  ADD_PICTURE: "add_picture",
  CHANGE_PICTURE: "change_picture",
  DELETE_PICTURE: "delete_picture",
};

export const SAVE_MISSIONS_ACTIONS = {
  PUBLISH: "PUBLISH",
  SAVE: "SAVE",
};

export const MISSION_STATUS = {
  CREATED: "created",
  PENDING: "pending",
  FINISHED: "finished",
  SAVED: "saved",
  NOT_FOUND: "not_found",
  PUBLISHED: "published",
  ERROR_SAVING: "error_saving",
  DRAFT: "draft",
  CLIENT_FINISHED: "CLIENT_FINISHED",
  ALREADY_SAVED: "evaluation-already-saved-or-closed",
};
export const ORDER_DIR = {
  ASC: "asc",
  DESC: "desc",
};

export const SYMBOLS = { DASH: "-" };

export const MINCHARMISSIONNAME = 30;
export const MAXCHARMISSIONNAME = 60;
export const MINWORDMISSIONDESCRIPTION = 50;

export const SCOPES = {
  PERSO: "perso",
  MACRO: "macro",
  ADMIN: "admin",
  READ: "read",
};

export const BALANCESHEET_AVERAGES_TYPE = {
  PROJECTS: "projects",
  TOTAL: "total",
};

export const EVALUATE_OPTIONS = [
  {
    val: "external_contact",
    lb: {
      id: "external_contact_option",
      defaultMessage: "Contact Externe",
    },
  },
];

export const BALANCESHEET_EVALUATION_MESSAGE = {
  FINISHED:
    "Votre évaluation a  déjà été enregistrée. Veuillez contacter votre manager pour toute question / mise à jour de l'évaluation.",
  SAVED:
    "Votre évaluation vient d’être sauvegardée et envoyée à Davidson. Votre manager et vous recevrez un email afin de convenir d’un rendez-vous.",
  EXPIRED:
    "Le lien de votre bilan annuel n'est plus valide. Contacter votre manager pour obtenir un nouveau lien.",
  ERROR: "Une erreur technique est survenue. Veuillez contacter Twister.",
};

export const ANNUAL_BALANCESHEET_VALIDATION_MODAL_TITLE =
  "Erreur de validation";
export const ANNUAL_BALANCESHEET_VALIDATION_MODAL_MESSAGE =
  "Veuillez corriger les erreurs du formulaire et remplir tous les champs obligatoires.";
export const ANNUAL_BALANCESHEET_VALIDATION_MODAL_TITLE_ID =
  "annual_balancesheet_validation_modal_title";
export const ANNUAL_BALANCESHEET_VALIDATION_MODAL_MESSAGE_ID =
  "annual_balancesheet_validation_modal_message";
export const ANNUAL_BALANCESHEET_SALARY_NOT_CREATED_ACTION =
  "salary-not-created";
export const ANNUAL_BALANCESHEET_SALARY_NOT_CREATED_MODAL_TITLE =
  "Salaire non créé";
export const ANNUAL_BALANCESHEET_SALARY_NOT_CREATED_MODAL_MESSAGE =
  "La nouvelle ligne de salaire n'a pas pu être créée, le bilan n'a donc pas été validé. Vérifiez qu'un salaire est actif à la date d'application de l'augmentation, puis validez à nouveau.";
export const ANNUAL_BALANCESHEET_SALARY_NOT_CREATED_MODAL_TITLE_ID =
  "annual_balancesheet_salary_not_created_modal_title";
export const ANNUAL_BALANCESHEET_SALARY_NOT_CREATED_MODAL_MESSAGE_ID =
  "annual_balancesheet_salary_not_created_modal_message";

export const BALANCESHEET_EVALUATION_STATUS = {
  UNFINISHED: "CONSULTANT_UNFINISHED",
  FINISHED: "FINISHED",
  CONSULTANT_CREATED: "CONSULTANT_CREATED",
  CONSULTANT_PENDING: "CONSULTANT_PENDING",
  PENDING: "PENDING",
  CREATED: "CREATED",
  CONSULTANT_FINISHED: "CONSULTANT_FINISHED",
  PUBLISHED: "PUBLISHED",
};

export const TRAINING_MAX_FILE_SIZE = {
  value: 500000,
  fr: "500Ko",
  en: "500Kb",
};

export const BILLING_MAX_FILE_SIZE = {
  value: 7000000,
  fr: "7Mo",
  en: "7Mb",
};

export const ACCEPTED_TYPES = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];
export const BALANCESHEET_SALARY_FIELDS = {
  RELATED_FIELD: "related-field",
  SOURCE_FIELDS: "source-fields",
};
export const ENTITY_ACCESS_RIGHTS = {
  GET: "get",
  UPDATE: "update",
  DELETE: "delete",
};

export const HISTORY_SUBCONTRACTOR_BY_FILTERS_KEYS_ID = {
  id: "id",
  subcontractorId: "subcontractor-id",
  subcontractorCompanyId: "subcontractor-company-id",
};
export const DASHBOARD_REQUIRED_ROLES = [
  DASHBOARD_ROLES.ROLE_GET_DASHBOARD_IC ||
    DASHBOARD_ROLES.ROLE_GET_DASHBOARD_ED ||
    DASHBOARD_ROLES.ROLE_GET_DASHBOARD_CL ||
    DASHBOARD_ROLES.ROLE_GET_DASHBOARD_MISSIONS ||
    DASHBOARD_ROLES.ROLE_GET_DASHBOARD_BILLING_STATS ||
    DASHBOARD_ROLES.ROLE_GET_DASHBOARD_FAE ||
    DASHBOARD_ROLES.ROLE_GET_DASHBOARD_RATIO,
];
export const MUTUAL_DASHBOARD_REQUIRED_ROLES = [
  MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_IC ||
    MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_FDM ||
    MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_ED ||
    MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_KO ||
    MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_CL ||
    MUTUAL_DASHBOARD_ROLES.ROLE_GET_MUTUAL_OK,
];
export const MANAGER_TOOLS_REQUIRED_ROLES = [
  ROLE_TOOL_MANAGER,
  ROLE_TOOL_MANAGER_MISSION,
  ROLE_TOOL_MANAGER_CLIENT,
  ROLE_TOOL_MANAGER_WORKER,
  ROLE_TOOL_MANAGER_PROSPECTION,
  ROLE_TOOL_MANAGER_SALARY,
  ROLE_TOOL_MANAGER_FAF,
];
export const routeMappings = [
  { role: MUTUAL_DASHBOARD_REQUIRED_ROLES, route: "/dashboard/shared/ic" },
  { role: MISSION_ROLES.ROLE_GET_MISSION_LIST, route: "/missions" },
  { role: ROLE_GET_CORRESPONDANCE, route: "/dashboard/correspondence" },
  { role: ROLE_GET_MISSION_BILL_TABLE, route: "/inputs/spreadsheet" },
  { role: DASHBOARD_REQUIRED_ROLES, route: "/dashboard" },
  { role: ROLE_IMPORT_EXTERNAL_TRAINING, route: "/training" },
  { role: MANAGER_TOOLS_REQUIRED_ROLES, route: `/${MANAGER_TOOLS_PATH}` },
];

export const FILTERS_FOR_NAMES = {
  CLIENT: "client",
  PERSON: "person",
  PROSPECTION: "prospection",
};

export const EXPORT_BUTTONS = {
  CA: "export-ca",
  CORRESPONDENCE: "export-correspondence",
};
export const ASSIGNMENT_RESPONSE_OPTIONS = {
  YES: "yes",
  YES_AND_DETACH: "yes-and-detach",
  NO: "no",
};

export const ANNUAL_BALANCESHEET_YEARS = {
  NUMBER_OF_PREVIOUS_YEARS_TO_SHOW: 5,
  NUMBER_OF_NEXT_YEARS_TO_SHOW: 1,
};

export const BALANCESHEET_STATUS = {
  CREATED: "CREATED",
  PENDING: "PENDING",
  FINISHED: "FINISHED",
  SAVED: "SAVED",
  PUBLISHED: "PUBLISHED",
  CONSULTANT_FINISHED: "CONSULTANT_FINISHED",
  CONSULTANT_PENDING: "CONSULTANT_PENDING",
  CONSULTANT_UNFINISHED: "CONSULTANT_UNFINISHED",
  CONSULTANT_CREATED: "CONSULTANT_CREATED",
};

export const IA_PROFILE = "ia";
export const MGR_PROFILE = "mgr";
export const DSOC_PROFILE = "dsoc";
export const MANAGER_PROFILES = ["mgr", "dsoc", "dg", "ia", "pdt", "df", "dsi"];
export const MANAGER_PROFILE_INITIALS = "MA";
export const ADMIN_INITIALS = "AD";

export const API_ERROR_CODE = {
  MISSION_HAS_BILLS: "mission_has_bills",
  END_DATE_BEFORE_BILL: "end_date_before_bill",
  START_DATE_AFTER_BILL: "start_date_after_bill",
  INVALID_MISSION_NAME: "invalid_mission_name",
  MISSION_BILL_AFTER_MISSION_END_DATE: "mission_bill_after_mission_end_date",
  MISSION_BILL_BEFORE_MISSION_START_DATE:
    "mission_bill_before_mission_start_date",
  WORKER_IS_BUSY: "worker_is_busy",
  WORKER_IS_OUT: "worker_is_out",
  INTERNAL_SERVER_ERROR: "internal_server_error",
  MISSION_NOT_FOUND: "mission_not_found",
  ID_SHOULD_BE_A_NUMBER: "id_should_be_a_number",
  MISSION_ID_SHOULD_BE_A_NUMBER: "mission_id_should_be_a_number",
  MONTH_SHOULD_BE_A_NUMBER: "month_should_be_a_number",
  YEAR_SHOULD_BE_A_NUMBER: "year_should_be_a_number",
};

export const API_ERRORS = [
  {
    code: API_ERROR_CODE.INTERNAL_SERVER_ERROR,
    errorMessage: {
      messageId: "internal_server_error_api_error_msg",
      messageDefault:
        "Une erreur interne est survenue. Veuillez réessayer plus tard.",
    },
  },
  {
    code: API_ERROR_CODE.MISSION_NOT_FOUND,
    errorMessage: {
      messageId: "mission_not_found_api_error_msg",
      messageDefault:
        "Mission introuvable. Veuillez vérifier l’identifiant fourni.",
    },
  },
  {
    code: API_ERROR_CODE.ID_SHOULD_BE_A_NUMBER,
    errorMessage: {
      messageId: "id_should_be_a_number_api_error_msg",
      messageDefault: "L’identifiant fourni doit être un nombre.",
    },
  },
  {
    code: API_ERROR_CODE.MISSION_ID_SHOULD_BE_A_NUMBER,
    errorMessage: {
      messageId: "mission_id_should_be_a_number_api_error_msg",
      messageDefault: "L’identifiant de la mission doit être un nombre.",
    },
  },
  {
    code: API_ERROR_CODE.MONTH_SHOULD_BE_A_NUMBER,
    errorMessage: {
      messageId: "month_should_be_a_number_api_error_msg",
      messageDefault:
        "Le mois doit être spécifié sous forme de nombre (1 à 12).",
    },
  },
  {
    code: API_ERROR_CODE.YEAR_SHOULD_BE_A_NUMBER,
    errorMessage: {
      messageId: "year_should_be_a_number_api_error_msg",
      messageDefault: "L’année doit être un nombre valide.",
    },
  },
  {
    code: API_ERROR_CODE.MISSION_HAS_BILLS,
    errorMessage: {
      messageId: "delete_mission_with_bills_api_error_msg",
      messageDefault:
        "Impossible de supprimer cette mission car celle-ci a du CA de renseigné.",
    },
  },
  {
    code: API_ERROR_CODE.END_DATE_BEFORE_BILL,
    errorMessage: {
      messageId: "edit_mission_with_end_date_before_bill_api_error_msg",
      messageDefault:
        "Date de fin invalide: Présence de CA sur le(s) mois postérieur(s). La date ne peut être antérieur au",
    },
  },
  {
    code: API_ERROR_CODE.START_DATE_AFTER_BILL,
    errorMessage: {
      messageId: "edit_mission_with_start_date_after_bill_api_error_msg",
      messageDefault:
        "Date de début invalide: Présence de CA sur le(s) mois antérieur(s). La date ne peut être postérieur au",
    },
  },
  {
    code: API_ERROR_CODE.INVALID_MISSION_NAME,
    errorMessage: {
      messageId: "edit_mission_with_characters_missing_api_error_msg",
      messageDefault:
        "Le nom de la mission doit être compris entre 30 et 60 caractères sans compter les espaces.",
    },
  },
  {
    code: API_ERROR_CODE.MISSION_BILL_AFTER_MISSION_END_DATE,
    errorMessage: {
      messageId: "edit_mission_with_too_late_bill_month_api_error_msg",
      messageDefault:
        "Le mois de la facturation ne peut pas être postérieur au mois de fin de mission.",
    },
  },
  {
    code: API_ERROR_CODE.MISSION_BILL_BEFORE_MISSION_START_DATE,
    errorMessage: {
      messageId: "edit_mission_with_too_early_bill_month_api_error_msg",
      messageDefault:
        "Le mois de la facturation ne peut pas être antérieur au mois de début de mission.",
    },
  },
  {
    code: API_ERROR_CODE.WORKER_IS_BUSY,
    errorMessage: {
      messageId: "edit_mission_with_busy_worker_api_error_msg",
      messageDefault:
        "Le consultant ou sous-traitant est déjà en mission sur cette période.",
    },
  },
  {
    code: API_ERROR_CODE.WORKER_IS_OUT,
    errorMessage: {
      messageId: "worker_is_out",
      messageDefault:
        "Le consultant n'est plus sous contrat, si vous souhaitez créer une mission avec ce consultant, assurez-vous qu'il possède un contrat actif.",
    },
  },
];

export const DOCUMENTS_TAGS = {
  TAG_DAV_WLC_LETTER: "TAG_DAV_WLC_LETTER",
  TAG_DAV_EMPL_CERT: "TAG_DAV_EMPL_CERT",
  TAG_DAV_INS_CERT: "TAG_DAV_INS_CERT",
  TAG_MISSION_ORDER: "TAG_MISSION_ORDER",
  TAG_SERVICE_CONTRACT: "TAG_SERVICE_CONTRACT",
  TAG_DAV_TEST_PERIOD: "TAG_DAV_TEST_PERIOD",
  TAG_DAV_NON_COMP: "TAG_DAV_NON_COMP",
  TAG_LIAISON_MAIL: "TAG_LIAISON_MAIL",
};

export const DOCUMENTS_BASE_URL_BY_ENTITY = {
  STAFF: "/directory/staff/document",
  CONSULTANT: "/directory/consultant/document",
  MISSION: "/mission/document",
};

export const ENTITY_TABLE_NAME = {
  SUBCONTRACTOR: "subcontractor",
  SUBCONTRACTING_COMPANY: "subcontracting-company",
  CLIENT: "client",
  BILLING_CLIENT: "billing-client",
  STAFF: "staff",
  PROSPECTION: "prospection",
  MISSION: "mission",
  BILLING: "billing",
  DASHBOARD: "dashboard",
  SHARED_DASHBOARD: "shared-dashboard",
  CORRESPONDENCE: "correspondence",
  TRAINING: "training",
  TOOLS: "tools",
};

export const BALANCESHEET_TABLE_ICON_SETTINGS = {
  calendar: { className: "calendar-icon-class" },
  user: { className: "user-icon-class" },
  comment: { className: "comment-icon-class", height: 25 },
  salary: { className: "salary-icon-class", height: 25 },
};

export const marginForUserIcon = 12;
export const marginForOtherIcons = 5;
export const MISSION_BALANCESHEET_TOTAL = 20;

export const EXPORT_FILE_TYPE = {
  IC: "IC",
  BAR_CART: "BAR_CHART",
};

export const PROFILES_REQUIRING_ASSIGNED_BRANCHES = [
  "dsoc",
  "rdd",
  "mgr",
  "ia",
];

export const STAFF_PROFILES = [
  "rdd",
  "ads",
  "adv",
  "radv",
  "gp",
  "rgp",
  "mgr",
  "dsoc",
  "si",
  "ada",
  "rh",
  "sec",
  "dfin",
  "dg",
  "pdt",
  "ia",
  "rbu",
  "dsi",
  "cdc",
  "cge",
  "law",
  "asr",
  "wyo",
  "climate",
  "rd",
  "fin",
  "clrz",
  "twi",
  "forma",
  "itny",
  "rfin",
  "rada",
];

export const HTTP_STATUS_CODE = {
  UNAUTHORIZED: 401,
  RESTRICTED_ACCESS: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  PAYLOAD_TOO_LARGE: 413,
};
export const ROLE_MATCH_MODE = {
  AND: "AND",
  OR: "OR",
};

export const SCHOOL_NOT_SET = "not_set";
